export const LOAD_PREMIUM_SUCCESS = 'LOAD_PREMIUM_SUCCESS';



/** WEBPACK FOOTER **
 ** ./src/core/premium/action-types.js
 **/